import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {};

export const IntegerEmptyState: React.FC<IProps> = () => {
  return (
    <Flex flexDirection={'column'}>
      <Text textStyle={'textBody'}>No data available</Text>
    </Flex>
  );
};
